export const DOCUMENT_CSS_TEMPLATE = `@namespace epub 'http://www.idpf.org/2007/ops';

@media print {
  * {
    display:none !important;
  }
}

parsererror {
  display: none !important;
}

/* RS Pub Positioning */
html {
  margin: 0 !important;
  padding: 0 !important;
}

body {
  margin: 0;
  padding: 0;
  overflow-y: hidden;
  top: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-touch-callout: none; /* Disables iOS touch-hold save image menu */
  FIXED_WIDTH_RULE
  FIXED_HEIGHT_RULE
}

body.has-zoom {
  margin: 0 !important;
  max-width: none !important;
}

body.readium-enabled {
  /*
  * adding extra margin at the bottom to have some space between actual content and footer.
  * 70px is just enough to keep tooltips in scrubbar from overlapping the content.
  * adjustment for footer/tts is handled by css of content class div in ReaderLayout.
  */
  margin: 0 0 70px 0!important; 
  overflow-x: hidden;
}

body img {
  max-width: 100% !important;
  height: auto !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

body math,
body .mjx-chtml,
body .MathJax_CHTML {
  user-select: none;
}

body iframe {
  min-height: 400px;
  overflow-y: auto;
}

body.selecting-text-touch {
  -webkit-user-select: none;
  user-select: none;
  overflow-x: hidden !important;
}

#MathJax_Message {
  display: none !important;
  user-select: none;
}

body .cpl-html {
  position: relative;
  width: 1000px;
}

.rs-inline-display {
  z-index: 300;
  position: absolute;
  pointer-events: none;
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
  background-color: transparent !important;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  transition: fill 0.3s;
  cursor: pointer;
}

.highlight-focused {
outline: 5px auto -webkit-focus-ring-color;
outline: 5px auto -moz-mac-focusring;
outline: 5px auto Highlight;
outline-offset: 2px;
}

.rs-inline-button {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  color: transparent !important;
  width: 1px;
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  left: -999999px;
}

.rs-inline-button:focus {
  outline: none;
  outline-offset: 0;
}

.rs-inline-display-copied-text {
  z-index: 200;
}

.rs-inline-display-rectangle {
  display: block;
  position: absolute;
  pointer-events: all;
}

.rs-inline-display.is-highlighting > .rs-inline-display-rectangle {
  pointer-events: none;
}

.rs-inline-display.is-focused {
  outline-width: 3px;
  outline-style: solid;
}

.rs-inline-display-copied-text > .rs-inline-display-rectangle {
  fill: none;
  stroke-width: 0.2rem;
  stroke: black;
}

::selection {
  background-color: ACTIVE_SELECTION_COLOR !important;
}

::-moz-selection {
  background-color: ACTIVE_SELECTION_COLOR !important;
}

/* unsaved */
.rs-inline-display-highlight.unsaved,
.rs-inline-display-note.unsaved {
  mix-blend-mode: MIX_BLEND_MODE;
}

.rs-inline-display-highlight.unsaved > .rs-inline-display-rectangle,
.rs-inline-display-note.unsaved > .rs-inline-display-rectangle {
  background-color: SELECTION_COLOR;
}

/* yellow */
.rs-inline-display-highlight.yellow,
.rs-inline-display-highlight.light-yellow,
.rs-inline-display-note.yellow,
.rs-inline-display-note.light-yellow{
  mix-blend-mode: MIX_BLEND_MODE;
}

.rs-inline-display-highlight.yellow > .rs-inline-display-rectangle ,
.rs-inline-display-highlight.light-yellow > .rs-inline-display-rectangle ,
.rs-inline-display-note.yellow > .rs-inline-display-rectangle ,
.rs-inline-display-note.light-yellow > .rs-inline-display-rectangle {
  background-color: HIGHLIGHT_COLOR_1 !important;
  border-color: HIGHLIGHT_BORDER_1 !important;
  border-width: 2px;
  border-style: solid;
}

.rs-inline-display-highlight.yellow:hover > .rs-inline-display-rectangle ,
.rs-inline-display-highlight.light-yellow:hover > .rs-inline-display-rectangle ,
.rs-inline-display-note.yellow:hover > .rs-inline-display-rectangle ,
.rs-inline-display-note.light-yellow:hover > .rs-inline-display-rectangle {
  background-color: HIGHLIGHT_HOVER_1;
}

/* green */
.rs-inline-display-highlight.green,
.rs-inline-display-highlight.light-green,
.rs-inline-display-note.green,
.rs-inline-display-note.light-green {
  mix-blend-mode: MIX_BLEND_MODE;
}

.rs-inline-display-highlight.green > .rs-inline-display-rectangle ,
.rs-inline-display-highlight.light-green > .rs-inline-display-rectangle ,
.rs-inline-display-note.green > .rs-inline-display-rectangle ,
.rs-inline-display-note.light-green > .rs-inline-display-rectangle {
  background-color: HIGHLIGHT_COLOR_2 !important;
  border-color: HIGHLIGHT_BORDER_2 !important;
  border-width: 2px;
  border-style: solid;
}

.rs-inline-display-highlight.green:hover > .rs-inline-display-rectangle ,
.rs-inline-display-highlight.light-green:hover > .rs-inline-display-rectangle ,
.rs-inline-display-note.green:hover > .rs-inline-display-rectangle ,
.rs-inline-display-note.light-green:hover > .rs-inline-display-rectangle {
  background-color: HIGHLIGHT_HOVER_2;
}

/* red */
.rs-inline-display-highlight.red,
.rs-inline-display-highlight.light-orange,
.rs-inline-display-note.red,
.rs-inline-display-note.light-orange {
  mix-blend-mode: MIX_BLEND_MODE;
}

.rs-inline-display-highlight.red > .rs-inline-display-rectangle ,
.rs-inline-display-highlight.light-orange > .rs-inline-display-rectangle ,
.rs-inline-display-note.red > .rs-inline-display-rectangle ,
.rs-inline-display-note.light-orange > .rs-inline-display-rectangle {
  background-color: HIGHLIGHT_COLOR_3 !important;
  border-color: HIGHLIGHT_BORDER_3 !important;
  border-width: 2px;
  border-style: solid;
}

.rs-inline-display-highlight.red:hover > .rs-inline-display-rectangle ,
.rs-inline-display-highlight.light-red:hover > .rs-inline-display-rectangle ,
.rs-inline-display-note.red:hover > .rs-inline-display-rectangle ,
.rs-inline-display-note.light-red:hover > .rs-inline-display-rectangle {
  background-color: HIGHLIGHT_HOVER_3;
}

/* blue */
.rs-inline-display-highlight.blue,
.rs-inline-display-highlight.light-blue,
.rs-inline-display-note.blue,
.rs-inline-display-note.light-blue{
  mix-blend-mode: MIX_BLEND_MODE;
}

.rs-inline-display-highlight.blue > .rs-inline-display-rectangle ,
.rs-inline-display-highlight.light-blue > .rs-inline-display-rectangle ,
.rs-inline-display-note.blue > .rs-inline-display-rectangle ,
.rs-inline-display-note.light-blue > .rs-inline-display-rectangle {
  background-color: HIGHLIGHT_COLOR_4 !important;
  border-color: HIGHLIGHT_BORDER_4 !important;
  border-width: 2px;
  border-style: solid;
}

.rs-inline-display-highlight.blue:hover > .rs-inline-display-rectangle ,
.rs-inline-display-highlight.light-blue:hover > .rs-inline-display-rectangle ,
.rs-inline-display-note.blue:hover > .rs-inline-display-rectangle ,
.rs-inline-display-note.light-blue:hover > .rs-inline-display-rectangle {
  background-color: HIGHLIGHT_HOVER_4;
}

.rs-disable-pointer-events, .rs-disable-pointer-events * {
  pointer-events: none !important;
}

@keyframes search-result-svg {
  from {
    opacity: 0.6;
  }
  to {
    opacity: 0.25;
  }
}

@keyframes search-result-container {
  from {
    transform: scale(1.5);
  }
  to {
    transform: scale(1);
    box-shadow: none;
  }
}

.rs-inline-display-highlight.search-result {
  outline-width: 2px;
  outline-style: solid;
  outline-color: yellow;
  animation: search-result-container;
  animation-duration: 2s;
  pointer-events: none;
}

.rs-inline-display-highlight.search-result svg {
  pointer-events: none;
  animation: search-result-svg;
  animation-duration: 5s;
  fill: yellow;
}

.is-tts-active {
  background-color: rgba(227, 242, 246, 0.3);
  box-shadow: 0 0 4px rgba(0, 40, 80, 0.5);
}

svg.spotlight {
  overflow: visible;
  position: absolute;
  fill: SPOTLIGHT_COLOR;
  mix-blend-mode: MIX_BLEND_MODE;
  transform: scale(1.4);
  transition: transform 150ms ease-out, opacity 5s ease;
  stroke: #0F1215;
  stroke-width: 2px;
}

svg.tts-underline {
  overflow: visible;
  position: absolute;
  fill: black;
}

:root[style*='readium-night-on'] svg.tts-underline {
  fill: white;
}

/*
    PAGE BREAKS FOR EPUBS THAT DO NOT FOLLOW SPEC
*/

*[epub|type~='pagebreak'][hidden] {
  display: inline !important;
  visibility: hidden !important;
}

/*
    Screen-reader only visibility for within the iframe
    Automatically generated pagebreaks need to also use this style so that they can have focus.
*/

.rs-screen-reader-only,
.rs-auto-pagebreak {
  clip: rect(1px, 1px, 1px, 1px);
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
}

/*
    Fix an issue with PDFs while using a high-contrast browser plugin
    This was also added to template.css in pdfjs-epub-builder, but replicated here to avoid reprocessing.
*/
.textLayer, .annotationLayer {
  z-index: 1;
}

.annotationLayer {
  position: relative;
}

.svgCover {
  mix-blend-mode: normal !important;
}

.hiddenSvgOverElement {
  pointer-events: none;
  z-index: 400;
  position: absolute;
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
}

.hiddenSvgOverElement rect {
  pointer-events: all;
  cursor: pointer;
  background-color: transparent !important;
}
`;
